import React from "react";
import ReactDOM from "react-dom";
import AppProviders from "@app/containers/AppProviders";
import App from "@app/containers/App";
import { initDatadogRum } from "@services/datadog";
import { unregister } from "./registerServiceWorker";

initDatadogRum();

ReactDOM.render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById("root")
);

unregister();
